export default {
  dialogTitle: {
    notes: 'Title of the import dialog',
    message: 'Import cart',
  },
  helpContent: {
    header: {
      notes: 'Title of the help section',
      message: 'how to import articles to the cart',
    },
    fileFormat: {
      header: {
        notes: 'Header for the supported file formats section',
        message: 'Supported file formats',
      },
      simpleFormat: {
        notes: 'Content of the first paragraph in the file format section',
        message:
          "1. A simple two-column format is convenient for creating importable .csv files from scratch. The requirements are that column 1 should contain article ID's, column 2 should contain quantity and there should be no headers. You can populate a table like this with as many rows as you’d like.",
      },
      exportFormat: {
        notes: 'Content of the second paragraph in the file format section',
        message:
          '2. The SAM “export format” is what you get when you export a cart from SAM, and it contains the below-listed column headers. To successfully import using this format, make sure each line is populated with appropriate fields for “Article #” and “Qty”.',
      },
    },
    exampleFiles: {
      header: {
        notes: 'Header for the example files section',
        message: 'Example files',
      },
      body: {
        notes: 'Body for the example files section',
        message:
          'Below you will find template files that you can download and use as a starting point for creating your own importable .csv files.',
      },
    },
  },

  importButton: {
    notes: 'Title of the import button',
    message: 'Import',
  },
  resetFileButton: {
    notes: 'Title of reset selected file button',
    message: 'Select a different file',
  },
  selectFileButton: {
    notes: 'Title of select file button',
    message: 'Select file',
  },
  successfulImport: {
    notes: 'Header for successful import',
    message: 'Successfully imported',
  },
  importFailed: {
    notes: 'Header for import failed accordion',
    message: 'Import failed',
  },
};
